import React, { SetStateAction, useState } from 'react'
import { Select, SelectChangeEvent, MenuItem, FormControl, OutlinedInput, Box} from '@mui/material'
import { Regions } from 'src/constant/Region';
// import ManageRegion from './ManageRegion';
import { useAdAchiveStore } from 'src/stores/AdAchiveStore';

//사용자 데이터로부터 기본값을 받아옴
//ManageRegion 을 사용해 Chips 표현

interface Props{
    setPage : React.Dispatch<SetStateAction<number>>
}

const RegionSelectorAdminAchive = ({setPage}:Props) => {
    const contents = Regions
    const menuProps = {
        PaperProps: {
            sx: {
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
          TransitionProps: {
            onEntering: (menuElement: HTMLElement) => {
              menuElement.scrollTop = 0;
            },
          },
    }
    const sx = {
            height:46
    }
    const [wideloc,setWideLoc] = useState('')
    const [cityloc,setCityLoc] = useState('')
    const setField = useAdAchiveStore((state)=>state.setField)


    const handleKeyChange = (e:SelectChangeEvent<string>)=>{
        setWideLoc(e.target.value)
        if(wideloc){
            setCityLoc('')
        }
        if (e.target.value === ''){
            setPage(1)
            setField('wide_Loc','')
            setField('city_Loc','')
        }
    }
    const handleValueChange = (e: SelectChangeEvent<string>) => {
        const newCity_loc = e.target.value;
        setCityLoc(newCity_loc);
        setPage(1)
        setField('wide_Loc',wideloc.slice(0, 2))
        setField('city_Loc',newCity_loc)
      };

  return (
    <>
        <Box sx={{ display: "flex", gap: "10px"}}>
        <FormControl fullWidth>
        <Select
            displayEmpty
            value={wideloc}
            onChange={handleKeyChange}
            renderValue={(selected) => selected as string || "시/도"}
            input={<OutlinedInput notched={false} name="시/도"/>}
            MenuProps={menuProps}
            sx={sx}
            >
            <MenuItem value="">
                시/도 선택
            </MenuItem>
            {Object.keys(contents).map((region)=>(
                <MenuItem key={region} value={region}>
                    {region}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        <FormControl fullWidth >
        <Select
            value={cityloc}
            onChange={handleValueChange}
            renderValue={(selected) => selected || "시/군/구"}
            input={<OutlinedInput notched={false} name="시/군/구"/>}
            disabled={!wideloc}
            MenuProps={menuProps}
            displayEmpty
            sx={sx}>
            {(contents[wideloc] ?? []).map((district)=>(
                <MenuItem key={district} value={district}>
                    {district}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        </Box>
        {/* <ManageRegion user_area={locations} isModify={false} setUser_area={setLocations}/> */}
    </>
  )
}

export default RegionSelectorAdminAchive